import { db } from '@app/icare/client/db'
import { localCountQueryOptions, localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { jsonObjectFrom } from '@app/icare/db/query/jsonHelpers'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import { PharmacySchema } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { zodObjectRootKeys } from '@pkg/api/query'
import dayjs from 'dayjs'

export const patientPharmacyQueries = {
  /** Active relations only, with the joined `to: Pharmacy` object. Used by the tab bar. */
  forTabs: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientPharmacy'] } },
      query: db
        .selectFrom('patientPharmacy')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('pharmacy')
              .select(zodObjectRootKeys(PharmacySchema, 'pharmacy.'))
              .whereRef('pharmacy.id', '=', 'patientPharmacy.toId'),
          ).as('to'),
        )
        .where(eb => eb.or([eb('activeTo', 'is', null), eb('activeTo', '>=', dayjs().format('YYYY-MM-DD'))]))
        .orderBy('activeFrom', 'asc'),
    }),

  /** Total count of active + inactive relations — used by the tab bar. */
  totalCount: (patientId: PatientIdType) =>
    localCountQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientPharmacy'] } },
      query: db.selectFrom('patientPharmacy').where('patientId', '=', patientId).where('deletedAt', 'is', null),
    }),

  /** Bare columns, no join, no active filter. Used by the historical index table. */
  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientPharmacy'] } },
      query: db
        .selectFrom('patientPharmacy')
        .select(['id', 'toId', 'activeFrom', 'activeTo', 'deletedAt'])
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),
}
